/**
 * Timing Utilities - Debounce
 * @module utils/debounce
 */

/**
 * Creates a debounced function that delays invoking func until after
 * `delay` milliseconds have elapsed since the last time it was invoked.
 */
export function debounce<T extends (...args: any[]) => unknown>(
	fn: T,
	delay: number
): (...args: Parameters<T>) => void {
	let timeoutId: number | undefined;

	return function (this: unknown, ...args: Parameters<T>): void {
		if (timeoutId !== undefined) {
			window.clearTimeout(timeoutId);
		}
		timeoutId = window.setTimeout(() => {
			fn.apply(this, args);
			timeoutId = undefined;
		}, delay);
	};
}
